import React from "react"
import { Link } from "react-router-dom"

interface BreadcrumbProps {
    voce: string
}

function Breadcrumb(props: BreadcrumbProps) {
    let voce = props.voce
    return (
        <div className="row">
            <div className="col-12 col-xl-11">
                <p className="breadcrumb-title">Ti trovi in:</p>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to={process.env.CONTEXT_PATH + "/"}> Home </Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                        <strong> {voce} </strong>
                    </li>
                </ol>
            </div>
        </div>
    )
}
export default Breadcrumb
